import { useEffect, RefObject } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const useEnterpriseAdvantageAnimation = (
  sectionRef: RefObject<HTMLDivElement | null>,
  rowsRef: RefObject<HTMLDivElement | null>,
  isEnabled: boolean = true
) => {
  useEffect(() => {
    if (!isEnabled) return;

    const section = sectionRef.current;
    const rowsContainer = rowsRef.current;
    if (!section || !rowsContainer) return;

    const rows = rowsContainer.querySelectorAll("[data-advantage-row]");
    const rowsArray = Array.from(rows);

    // Set initial values - first visible, rest hidden
    rowsArray.forEach((row) => {
      gsap.set(row, { opacity: 0 });
    });

    // Timeline with scrub - works in both directions automatically
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 50%",
        end: "bottom bottom",
        scrub: 1,
      },
    });

    // Animate elements
    rowsArray.forEach((row, index) => {
      // Calculate timing - evenly distributed in timeline
      const totalAnimatableRows = rowsArray.length; // 4 elements to animate
      const segmentDuration = (1 / totalAnimatableRows) * 0.5;
      const startTime = (index - 1) * segmentDuration * 0.5;

      tl.to(
        row,
        {
          opacity: 1,
          duration: segmentDuration * 0.8,
          ease: "power2.inOut",
        },
        startTime
      );
    });

    return () => {
      tl.kill();
    };
  }, [sectionRef, rowsRef, isEnabled]);
};
